import { render, staticRenderFns } from "./CurvasPopularidadeTabela.vue?vue&type=template&id=2623511b&scoped=true"
import script from "./CurvasPopularidadeTabela.vue?vue&type=script&lang=js"
export * from "./CurvasPopularidadeTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2623511b",
  null
  
)

export default component.exports